import { render, staticRenderFns } from "./MasterApp.vue?vue&type=template&id=710d0aa6&"
import script from "./MasterApp.vue?vue&type=script&lang=js&"
export * from "./MasterApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports